<template>
  <div id="animation-carousel" data-carousel="static">
    <!-- Carousel wrapper -->
    <template v-if="loading">
      <tear-card card-bg-color="#fff"
                 out-bg-color="gray"
                 out-bg-color-range="100"
                 class="tw-p-6">
        <div class="tw-border-b tw-border-dashed tw-border-gray-200 tw-pb-2 tw-mb-4 tw-flex tw-justify-between">
          <shine-loading body_width="60" size="sm" />
        </div>
        <div class="tw-flex tw-justify-between tw-mt-4">
          <shine-loading body_width="40" size="sm" />
          <shine-loading body_width="90" size="sm" />
        </div>
        <div class="tw-flex tw-justify-between tw-mt-4">
          <shine-loading body_width="50"  size="sm" />
          <shine-loading body_width="150"  size="sm" />
        </div>
        <div class="tw-flex tw-justify-between tw-mt-4">
          <shine-loading body_width="20"  size="sm" />
          <shine-loading body_width="60"  size="sm" />
        </div>
        <div class="tw-flex tw-justify-between tw-mt-4">
          <shine-loading body_width="80"  size="sm" />
          <shine-loading body_width="50"  size="sm" />
        </div>
        <div class="tw-flex tw-justify-between tw-mt-4">
          <shine-loading body_width="80" size="sm" />
          <shine-loading body_width="40" size="sm" />
        </div>
      </tear-card>
    </template>
    <div v-else-if="payments.length">
      <template v-for="payment in payments" :key="payment.id">
        <template v-for="det in payment.details" :key="det.id">
          <tear-card card-bg-color="#fff" out-bg-color="gray" out-bg-color-range="100" class="tw-hidden" :class="current === det.id && '!tw-block'">
            <div class="tw-pt-4 tw-pb-5 tw-px-6">
              <div class="tw-border-b tw-border-dashed tw-border-gray-500">
                <p class="tw-text-blue-dark-200 tw-text-[12px]">پرداخت مرتبط</p>
              </div>
              <div class="tw-mt-4 tw-flex tw-justify-between">
                <div>
                  <base-icon icon="money-bag" class="tw-align-middle tw-text-blue-dark-500 tw-ml-4" size="20" />
                  <span class="tw-text-blue-dark-200">مبلغ</span>
                </div>
                <span class="tw-inline-block tw-text-blue-dark-500">{{ new Intl.NumberFormat().format(det.amount) }} ریال</span>
              </div>
              <div class="tw-mt-4 tw-flex tw-justify-between">
                <div>
                  <base-icon icon="event" class="tw-align-middle tw-text-blue-dark-500 tw-ml-4" size="20" />
                  <span class="tw-text-blue-dark-200">تاریخ</span>
                </div>
                <span class="tw-inline-block tw-text-blue-dark-500 ltr">{{ mixin.methods.to_jalali(det.date_pay, 'long') }}</span>
              </div>
              <div class="tw-mt-4 tw-flex tw-justify-between">
                <div>
                  <base-icon icon="qr-code" class="tw-align-middle tw-text-blue-dark-500 tw-ml-4" size="20" />
                  <span class="tw-text-blue-dark-200">کد پیگیری</span>
                </div>
                <span class="tw-inline-block tw-text-blue-dark-500">{{ det.tracking_code || '-/-' }}</span>
              </div>
              <div class="tw-mt-4 tw-flex tw-justify-between">
                <div>
                  <base-icon icon="barcode" class="tw-align-middle tw-text-blue-dark-500 tw-ml-4" size="20" />
                  <span class="tw-text-blue-dark-200">شناسه حسابداری</span>
                </div>
                <span class="tw-inline-block tw-text-blue-dark-500">{{ det.fm_pardakht_id || '-/-' }}</span>
              </div>
              <div class="tw-mt-4 tw-flex tw-justify-between">
                <div>
                  <base-icon icon="key-visualizer" class="tw-align-middle tw-text-blue-dark-500 tw-ml-4" size="20" />
                  <span class="tw-text-blue-dark-200">نوع</span>
                </div>
                <span class="tw-inline-block tw-text-blue-dark-500">{{ det.type_pay_title || '-/-' }}</span>
              </div>
              <div class="tw-mt-4 tw-flex tw-justify-between">
                <div>
                  <base-icon icon="file-present" class="tw-align-middle tw-text-blue-dark-500 tw-ml-4" size="20" />
                  <span class="tw-text-blue-dark-200">فایل پیوست</span>
                </div>
                <div>
                  <template v-if="det.attachments.length" v-for="attach in det?.attachments" :key="attach.id">
                    <a :href="attach.download_url" target="_blank" class="tw-inline-block tw-text-blue-500">مشاهده فایل</a>
                  </template>
                  <span v-else>ندارد</span>
                </div>
              </div>
            </div>
          </tear-card>
        </template>
      </template>

      <div v-if="options.length > 1" class="tw-text-center tw-mt-4">
        <base-icon icon="arrow-circle-right"
                   @click="showPrev"
                   size="20"
                   :class="[
                     hasPrev && '!tw-text-blue-500 tw-cursor-pointer'
                   ]"
                   class="tw-inline-block tw-p-2 tw-text-blue-dark-100" />
        <div class="tw-mx-2 tw-inline-block tw-align-super">
          {{ options.indexOf(current) + 1 }}
          از
          {{ options.length }}
        </div>
        <base-icon icon="arrow-circle-left"
                   @click="showNext"
                   size="20"
                   :class="[
                     hasNext && '!tw-text-blue-500 tw-cursor-pointer'
                   ]"
                   class="tw-inline-block tw-p-2 tw-text-blue-dark-100" />
      </div>
    </div>
    <!--    Is Empty     -->
    <tear-card v-else
               card-bg-color="#fff"
               out-bg-color="gray"
               out-bg-color-range="100"
               class="tw-text-blue-dark-200 tw-flex tw-justify-center tw-items-center tw-text-tiny tw-font-regular">
      پرداخت مرتبطی ثبت نشده است
    </tear-card>
  </div>

</template>

<script setup>
import Currency from '@/components/partial/Currency.vue'
import {computed, getCurrentInstance, onMounted, ref, watch} from 'vue'
import Swal from 'sweetalert2'
import BaseIcon from "@/components/base/BaseIcon.vue";
import TearCard from "@/components/base/more/TearCard.vue";
import mixin from '@/mixin'
import ShineLoading from "@/components/loading/ShineLoading.vue";

const current = ref(null)
const { proxy } = getCurrentInstance()
const props = defineProps({
  payments: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const show_file = (url) => {
  Swal.fire({
    title: '',
    confirmButtonText: 'دانلود فایل',
    showCloseButton: true,
    text: 'فایل پیوست رسید تراکنش',
    imageUrl: url,
    imageWidth: 400,
    imageAlt: 'فایل پیوست',
  }).then((result) => {
    if (result.isConfirmed) {
      proxy.$toast('در حال دانلود فایل', 'info')
    }
  })
}

// مقداردهی اولیه هنگام mount
onMounted(() => {
  // setTimeout(() => {
  //   if (props.payments.length && props.payments[0].details.length) {
  //     current.value = props.payments[0].details[0].id
  //     alert(current.value)
  //   }
  // }, 200)
})



watch(() => props.payments, (newVal) => {
  if (newVal.length && newVal[0].details.length) {
    current.value = newVal[0].details[0].id
  }
})

const showNext = () => {
  let index = options.value.indexOf(current.value)
  if(options.value.length - 1 > index) {
    current.value = options.value[index+1]
  }
}
const hasNext = computed(() => {
  let index = options.value.indexOf(current.value)
  if(options.value.length - 1 > index) return true
  return false
})


const showPrev = () => {
  let index = options.value.indexOf(current.value)
  if(index > 0) {
    current.value = options.value[index-1]
  }
}



const hasPrev = computed(() => {
  let index = options.value.indexOf(current.value)
  if(index > 0) return true
  return false
})

const options = computed(() => {
  return props.payments?.flatMap(p => p.details.map(d => d.id)) || []
})

</script>

<style scoped type="scss">
.bg-triangle {
  position: relative;
}
.bg-triangle:before {
  content: '';
  display: block;
  height: 10px;
  width: 100%;
  background-image: url('/public/img/plain-triangle.png');
  background-position: center;
  position: absolute;
  transform: rotate(180deg);
  left: 0;
  bottom: -9px;
}
.bg-triangle:after {
  content: '';
  display: block;
  height: 10px;
  width: 100%;
  background-image: url('/public/img/plain-triangle.png');
  background-position: center;
  position: absolute;
  left: 0;
  top: -10px;
}
.list-group-item {
  width: 30px;
  height: 30px;
}
</style>
